export function timeInMilliseconds(): number {
    return new Date().getTime();
}

export function delay(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
}
